{
  "algorithmicNetwork": "Algorithmic Network",
  "psynera": "Psynera",
  "googleDrive": "Google Drive",
  "dropbox": "Dropbox",
  "faceId": "Face ID",
  "algorithmicWordmark": "Algorithmic",
  "networkWordmark": "Network",
  "retailistDesktop": "Retailist Desktop",
  "retailistApp": "Retailist App",
  "retailistStore": "Retailist Store",
  "retailistCloud": "Retailist Cloud",
  "retailistAi": "RetailistAI",
  "retailist": "Retailist",
  "fynlinkLlc": "Fynlink, LLC",
  "fynlink": "Fynlink",
  "localAts": "Local ATS",
  "shopify": "Shopify",
  "shopifyWordmark": "shopify",
  "wooCommerce": "WooCommerce",
  "macOs": "macOS",
  "windows": "Windows",
  "linux": "Linux",
  "calCom": "Cal.com",
  "calVideo": "Cal Video",
  "langChain": "LangChain",
  "langGraph": "LangGraph",
  "huggingFace": "Hugging Face",
  "huggingFaceCompact": "HuggingFace",
  "typeSafeAi": "TypeSafe AI",
  "ollama": "Ollama",
  "pytorch": "PyTorch",
  "fastai": "fastai",
  "tensorFlow": "TensorFlow",
  "keras": "Keras",
  "scikitLearn": "scikit-learn",
  "weightsAndBiases": "Weights & Biases",
  "onnx": "ONNX",
  "mlflow": "MLflow",
  "anthropic": "Anthropic",
  "python": "Python",
  "fastApi": "FastAPI",
  "docker": "Docker",
  "chrome": "Chrome",
  "firefox": "Firefox",
  "edge": "Edge",
  "brave": "Brave",
  "opera": "Opera",
  "github": "GitHub",
  "x": "X",
  "agents": "<Agents>",
  "helloEmail": "hello@algorithmic.network",
  "privacyEmail": "privacy@algorithmic.network",
  "legalEmail": "legal@algorithmic.network",
  "siteDomain": "algorithmic.network",
  "northStar": "North Star",
  "matt": "Matt M.",
  "mori": "MORI",
  "moriDomain": "moriobjects.com",
  "atelier": "Atelier No. 7",
  "weekender": "North Star Weekender",
  "marigold": "Marigold Wrap Dress",
  "fieldJacket": "Field Chore Jacket",
  "halo": "Halo frames",
  "afterRain": "After Rain",
  "cobaltTrench": "Cobalt trench",
  "arcSpeaker": "Arc 02 Speaker"
}
